import { allpeepPayloadEndpoint, allpeepNoPayloadEndpoint } from './helpers.js';
export const sso = (rawClient) => ({
    generic: {
        authenticate: allpeepPayloadEndpoint(rawClient, '/sso/generic'),
    },
    oidc: {
        authorize: allpeepNoPayloadEndpoint(rawClient, '/sso/oidc/{id}/authorize', 'get'),
        callback: allpeepNoPayloadEndpoint(rawClient, '/sso/oidc/{id}/callback', 'get'),
    },
});
